<script lang="ts">
import { defineComponent } from 'vue';
import router from '../../router';
import CheckBox from '../../components/CheckBox.vue';
import SolutoButton from '../../components/SolutoButton.vue';
import { mapActions } from 'vuex';

export default defineComponent({
  name: 'Permission',
  components: {
    Checkbox: CheckBox,
    Button: SolutoButton
  },
  data () {
    return {
      checkbox: false,
      showModal: false
    };
  },
  methods: {
    ...mapActions([
      'changePermission'
    ]),
    gotoOptout () {
      this.showModal = true;
    },
    changeValue (event: any) {
      this.checkbox = event[0];
    },
    gotoQ1 () {
      window.parent.postMessage(
        { solutoSurvey: 'startSurvey' }, '*'
      );
      this.changePermission(true);
      router.push({ path: '/survey/question1' });
    },
    goBack () {
      window.parent.postMessage(
        { solutoSurvey: 'stopSubscription' }, '*'
      );
      this.showModal = false;
    }
  }
});
</script>

<template>
  <div class="permission">
    <div class="permission-body">
      <p class="with-margin">{{ $t('permission_01_01') }}</p>
      <p>{{ $t('permission_01_02') }}</p>
      <p>{{ $t('permission_01_03') }}</p>
      <p class="with-top-margin">{{ $t('permission_01_04') }}</p>
      <p>{{ $t('permission_01_05') }}</p>
      <p>{{ $t('permission_01_06') }}</p>
      <p>{{ $t('permission_01_07') }}</p>
      <p class="with-top-margin">{{ $t('permission_01_08') }}</p>
      <p class="with-top-margin">{{ $t('permission_01_09') }}</p>
      <p class="with-top-margin">{{ $t('permission_01_10') }}   </p>
      <p class="with-top-margin">{{ $t('permission_01_11') }}</p>
      <p class="with-margin">{{ $t('permission_01_12') }}</p>
      <Button
          class="button"
          :color="'#e6e6e6'"
          :textColor="'#535353'"
          :size="'small'"
          :text="$t('stopSurvey')"
          @click="gotoOptout"
      />
    </div>
    <div class="permission-footer">
      <Checkbox
        class="checkbox"
        @change="changeValue($event)"
        :label="$t('confirmation')"
        :value="checkbox"
      />
      <Button
        class="button"
        :disabled="!checkbox"
        :size="'large'"
        :text="$t('accept')"
        @click="gotoQ1"
      />
    </div>

    <div v-if="showModal" class="modal-backdrop">
      <div class="modal" role="dialog" aria-modal="true">
        <p class="modal-body">{{ $t('stopQuestionnaire') }}</p>
        <div class="modal-actions">
          <button
            type="button"
            class="modal-action"
            @click="showModal = false"
          >
            {{ $t('no') }}
          </button>
          <button
            type="button"
            class="modal-action"
            @click="goBack()"
          >
            {{ $t('yes') }}
          </button>
        </div>
      </div>
    </div>

  </div>
</template>

<style lang="scss" scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
}

.modal {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 24px;
  width: 280px;
  max-width: calc(100vw - 48px);
  padding: 24px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow:
    0 8px 8px 1px rgba(0, 0, 0, 0.14),
    0 3px 8px 2px rgba(0, 0, 0, 0.12),
    0 5px 5px -3px rgba(0, 0, 0, 0.2);

  &-body {
    width: 100%;
    margin: 0;
    color: #000000;
    font-family: $font-family;
    font-size: 15px;
    font-weight: 700;
    line-height: 24px;
  }

  &-actions {
    display: flex;
    justify-content: flex-end;
    gap: 18px;
    width: 100%;
  }

  &-action {
    padding: 1px;
    border: none;
    background: transparent;
    color: #eb5505;
    font-family: $font-family;
    font-size: 13px;
    font-weight: 700;
    line-height: 20px;
    cursor: pointer;

    &:hover {
      opacity: 0.7;
    }
  }
}

.permission {
  background-color: $survey-background-color;

  &-body {
    padding: 0 18px 24px;
    height: calc(100vh - 235px);
    margin: 24px 18px 0;
    overflow: auto;
    border: solid 1px #e6e6e6;
    background-color: $survey-background-color;
    color: $survey-text-color;
    font-family: $font-family;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 1.5;

    p {
      color: $survey-text-color;
      font-family: $font-family;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 1.5;
    }

    .button {
      width: 178px;
    }
  }
  &-footer {
    height: 140px;
    margin: 18px 18px 0;
    background-color: $survey-background-color;
    .checkbox {
      margin: 0 0 58px;
    }
  }
}
</style>
